import React, { useState } from 'react';

import ModalDialog from '../../../../../organisms/ModalDialog/ModalDialog';
import { ButtonMinorAction } from '../../../../Btn/ButtonWrapper';
import { TooltipPlacement } from '../../../../../atoms/Tooltip';
import { useSonTranslation } from '../../../../../../translation/useSonTranslation';
import { Icons } from '../../../../../atoms/SVG';
import { EditorHelp } from './EditorHelp';
import { SONEditorConfig } from '../types';

type EditorHelpModal = {
  config?: SONEditorConfig;
};

export function EditorHelpModal({ config }: EditorHelpModal) {
  const { t } = useSonTranslation('Editor');

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <>
      <div className="editor__help-button-container">
        <ButtonMinorAction
          icon={Icons.KEYBOARD}
          text={t('keyboardHelp')}
          onClick={() => setModalOpen(true)}
          tooltipPlacement={TooltipPlacement.TOP}
        />
      </div>
      {modalOpen && (
        <ModalDialog closeModal={() => setModalOpen(false)} headline={t('keyboardHelp')}>
          <EditorHelp config={config} />
        </ModalDialog>
      )}
    </>
  );
}
